import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

interface VerifyMobileOtpRequestData {
  mobileOtp: string
}

export interface VerifyMobileOtpRequest extends Partial<AxiosRequestConfig> {
  params: VerifyMobileOtpRequestData
}

interface VerifyMobileOtpResponseData extends ResponseData {
  message: string
  success?: boolean
  userId?: number
}

export interface VerifyMobileOtpResponse extends AxiosResponse {
  data: VerifyMobileOtpResponseData
}

export function verifyEmailOtpAPI(
  { params }: VerifyMobileOtpRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params: { avoidClientSideAuth: true },
    method: "get",
    url: `/auth/email/verify-otp?emailOtp=${params.mobileOtp}`,
  }) as Promise<VerifyMobileOtpResponse>
}
